// test846
(846 && 0);
